import { useDispatch, useSelector } from "react-redux";

import actions from "@/actions";
import { RootState } from "@/reducers/types";
import { PlotPlanTypeType } from "@/sx-layout/components/settings/plotPlanSetting/models";

export const usePlotPlanSetting = () => {
  const dispatch = useDispatch();

  const plotPlanType = useSelector((state: RootState) => state.plotPlan.plotPlanType);

  const changePlotPlanMapType = (value: PlotPlanTypeType) => {
    dispatch(actions.plotPlan.changePlotPlanMapType(value));
  };

  return { plotPlanType, changePlotPlanMapType };
};
